<template>
  <div class="price-text">
    <div :style="flagSize">￥</div>
    <div :style="{ fontSize: `${highSize}px` }" class="font-bold">{{ prices[0] }}</div>
    <div :style="flagSize" v-if="prices[1]">.{{ prices[1] }}</div>
  </div>
</template>

<script>
export default {
  name: 'priceText',
  props: {
    price: {
      type: [String, Number],
      default: '0.00'
    },
    highSize: {
      type: Number,
      default: 18
    }
  },
  computed: {
    prices() {
      return (this.price + '').split('.')
    },
    flagSize() {
      return {
        fontSize: `${this.highSize - 6}px`
      }
    }
  }
}
</script>

<style lang="less" scoped>
.price-text {
  color: #333;
  font-family: HelveticaNeue-Medium, HelveticaNeue;
  display: flex;
  align-items: baseline;
  line-height: 1;
}
</style>
